import { CONST_AWS_API, CONST_ONE_API } from 'src/app/core/constants';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CommanSubscribeService } from '../services/comman-subscribe.service';
import { LandingPageService } from '../services/landing-page.service';
import { Auth, API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppService } from '../services/app.service';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private commanSubscribeService: CommanSubscribeService,
    private storageService: StorageService,
    private landingService: LandingPageService, private ngxLoader: NgxUiLoaderService) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    let userInfo = this.commanSubscribeService.userInfo;
    let user_Info = this.storageService.getItem("user_Info") || {};
    // return new Promise(res => {
    //   if (Object.keys(userInfo).length == 0) {
    //     this.ngxLoader.start();
    //     Auth.currentUserInfo()
    //       .then(user => {
    //         if (user && user.attributes) {
    //           let myInit = {
    //             headers: {},
    //             response: true,
    //             body: {
    //               email: user.attributes.email
    //             }
    //           }
    //           AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
    //             this.ngxLoader.stop();
    //             let userInfo = response.data.user;
    //             userInfo.signedIn = true;
    //             userInfo.access_token = userInfo.session_token;
    //             this.commanSubscribeService.sendUserInfo(userInfo);
    //             res(true);
    //           }).catch(error => {
    //             this.ngxLoader.stop();
    //             if (state.url.indexOf('stream') != -1 || state.url.indexOf('group-stream') != -1) {
    //               this.router.navigate(['/signup'], { queryParams: { returnUrl: state.url } });
    //             } else {
    //               this.router.navigate([''], { queryParams: { returnUrl: state.url } });
    //               setTimeout(() => {
    //                 this.landingService.openConsumerSignIn();
    //               }, 100);
    //             }
    //             this.commanSubscribeService.sendUserInfo({});
    //             res(false);
    //           });
    //         } else {
    //           this.ngxLoader.stop();
    //           if (state.url.indexOf('stream') != -1 || state.url.indexOf('group-stream') != -1) {
    //             this.router.navigate(['/signup'], { queryParams: { returnUrl: state.url } });
    //           } else {
    //             this.router.navigate([''], { queryParams: { returnUrl: state.url } });
    //             setTimeout(() => {
    //               this.landingService.openConsumerSignIn();
    //             }, 100);
    //           }
    //           this.commanSubscribeService.sendUserInfo({});
    //           res(false);
    //         }
    //       }).catch(err => {
    //         this.ngxLoader.stop();
    //         if (state.url.indexOf('stream') != -1 || state.url.indexOf('group-stream') != -1) {
    //           this.router.navigate(['/signup'], { queryParams: { returnUrl: state.url } });
    //         } else {
    //           this.router.navigate([''], { queryParams: { returnUrl: state.url } });
    //           setTimeout(() => {
    //             this.landingService.openConsumerSignIn();
    //           }, 100);
    //         }
    //         this.commanSubscribeService.sendUserInfo({});
    //         res(false);
    //       });
    //   } else if (Object.keys(userInfo).length != 0 && localStorage.isFanLoginUser) {
    //     res(true);
    //   } else {
    //     if (state.url.indexOf('stream') != -1 || state.url.indexOf('group-stream') != -1) {
    //       this.router.navigate(['/signup'], { queryParams: { returnUrl: state.url } });
    //     } else {
    //       this.router.navigate([''], { queryParams: { returnUrl: state.url } });
    //       setTimeout(() => {
    //         this.landingService.openConsumerSignIn();
    //       }, 100);
    //     }
    //     this.commanSubscribeService.sendUserInfo({});
    //     res(false);
    //   }
    // });


    return new Promise(res => {
      if (Object.keys(userInfo).length == 0) {
        // Prefer this tab's own per-org stored session (if any) over the shared flat
        // `user_Info` key below — this is what stops a reload/nav on Org A's tab from
        // picking up whatever org last logged in elsewhere in the same browser.
        const activeOrgId = this.storageService.getActiveOrgId();
        if (activeOrgId && this.commanSubscribeService.switchActiveOrg(activeOrgId)) {
          res(true);
          return;
        }
        this.ngxLoader.start();
        let myInit = {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": environment.AWS_Cognito.X_Api_Key,
            "Authorization": `Bearer ${user_Info.access_token}`
          },
          response: true,
          body: {
            // user_id: user_Info.id
          }
        }
        AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
          this.ngxLoader.stop();
          let userInfo = response.data.user;
          userInfo.signedIn = true;
          userInfo.access_token = userInfo.session_token;

          // if(userInfo && userInfo.user_phone_number && userInfo.date_of_birth
          //   && userInfo.user_display_name) {
              userInfo.is_profile_completed = true;              
          // } else {
          //   userInfo.is_profile_completed = false;
          //     this.router.navigateByUrl(`/user-dashboard/profile-settings/basic-info`);
          // }
          this.commanSubscribeService.sendUserInfo(userInfo);
          res(true);
        }).catch(error => {
          this.ngxLoader.stop();
          if (state.url.indexOf('stream') != -1 || state.url.indexOf('group-stream') != -1) {
            this.router.navigate(['/signup'], { queryParams: { returnUrl: state.url } });
            setTimeout(() => {
              this.landingService.openConsumerSignIn();
            }, 100);
          } else {
            const pageFrom = state?.root?.queryParams?.['pageFrom'];
            if (state.url.includes('community/preview')|| pageFrom === 'eventForm' || (state.url.includes('communityTipMessage'))) {
              res(true);
              return;
            } else {
              this.router.navigate([''], { queryParams: { returnUrl: state.url } });
            }
          }
          this.commanSubscribeService.sendUserInfo({});
          res(false);
        }); 
      } else if (Object.keys(userInfo).length != 0 && localStorage.isFanLoginUser) {
        res(true);
      } else {
        if (state.url.indexOf('stream') != -1 || state.url.indexOf('group-stream') != -1) {
          this.router.navigate(['/signup'], { queryParams: { returnUrl: state.url } });
          setTimeout(() => {
            this.landingService.openConsumerSignIn();
          }, 100);
          //removed else condition because after sign out it is continuously redirecting to signIn page even after clicked on signup page.
        }
        this.commanSubscribeService.sendUserInfo({});
        res(false);
      }
    });




  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let userInfo = this.commanSubscribeService.userInfo;
    if (userInfo && userInfo.id && userInfo.signedIn && localStorage.isFanLoginUser) {
      return true;
    } else {
      if (state.url.indexOf('stream') != -1 || state.url.indexOf('group-stream') != -1) {
        this.router.navigate(['/signup'], { queryParams: { returnUrl: state.url } });
        setTimeout(() => {
          this.landingService.openConsumerSignIn();
        }, 100);
      } else {
        this.router.navigate([''], { queryParams: { returnUrl: state.url } });
        setTimeout(() => {
          this.landingService.openConsumerSignIn();
        }, 100);
      }
      this.commanSubscribeService.sendUserInfo({});
      return false;
    }

    // let data = this.storageService.getItem("userInfo") || {};
    // if (data && data.id && data.signedIn && localStorage.isFanLoginUser) {
    //   return true;
    // } else {
    //   this.router.navigate([''], { queryParams: { returnUrl: state.url } });
    //   setTimeout(() => {
    //     this.landingService.openConsumerSignIn();
    //   }, 100);
    //   this.commanSubscribeService.sendUserInfo({});
    //   return false;
    // }

  }



}
